import {
	RECEIVE_ARTISTS,
	RECEIVE_WORKS,
	ReceiveWorks,
	ReceiveArtists
} from 'actions/WorksActions';
import { Reducer } from 'redux';
import {StoreState} from './_rootReducer';
import {Artist} from 'types/Artist';

export default function artistsReducer(
	state: Artist[] = [],
	action: ReceiveWorks | ReceiveArtists
): Artist[]{

	switch (action.type){

		case RECEIVE_ARTISTS: {
			return action.artists.slice();
		}

		case RECEIVE_WORKS: {
			let artists = state.slice();
			let firstWork = {};
			action.works.forEach((w, idx) => {
				if (!firstWork[w.artist]){
					firstWork[w.artist] = w.id
				}
			})
			return state.map(a => ({
				...a,
				firstWork: firstWork[a.name]
			}))
		}

		default:
			return state;

	}
}

